module.exports = __webpack_public_path__ + "img/aseos.567aa266.png";